"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AudioPlayer = void 0;
const audio_visualizer_1 = require("@shared-modules/utils/hooks/audio-visualizer");
const classnames_1 = __importDefault(require("classnames"));
const React = __importStar(require("react"));
const react_1 = require("react");
const icons_1 = require("../icons");
require("./styles.scss");
const AudioPlayer = (props) => {
    const { src, preview, onPlay } = props;
    const urlSource = typeof src === "string" ? src : undefined;
    const sources = typeof src === "object" ? src : [];
    const audioRef = (0, react_1.useRef)(null);
    const canvasRef = (0, react_1.useRef)(null);
    const [isAudioStarted, setIsAudioStarted] = (0, react_1.useState)(false);
    const [isPreviewHidden, setIsPreviewHidden] = (0, react_1.useState)(false);
    const [play, pause] = (0, audio_visualizer_1.useAudioVisualizer)(canvasRef, audioRef, {
        resolution: [1200, 1600],
        barGap: 15,
        barWidth: 6,
        fftSize: 64,
        barScale: 400,
        minBarHeight: 25,
        color: "#ff8787",
    }) || [];
    const playAudio = () => {
        var _a;
        (_a = audioRef.current) === null || _a === void 0 ? void 0 : _a.play();
        play === null || play === void 0 ? void 0 : play();
        setIsAudioStarted(true);
        setIsPreviewHidden(true);
        onPlay();
    };
    const resetAudio = () => {
        setIsAudioStarted(false);
        pause === null || pause === void 0 ? void 0 : pause();
    };
    const pauseAudio = () => {
        setIsAudioStarted(false);
        pause === null || pause === void 0 ? void 0 : pause();
    };
    return (React.createElement("div", { className: "c-audio-player" },
        React.createElement("div", { onClick: playAudio, className: (0, classnames_1.default)("c-audio-player__initial-preview", isPreviewHidden && "c-audio-player__initial-preview--hidden"), style: { backgroundImage: `url(${preview})` } },
            React.createElement(icons_1.PlayIcon, { color: "black" })),
        React.createElement("img", { src: preview, className: (0, classnames_1.default)("c-audio-player__preview", isAudioStarted && "c-audio-player__preview--active") }),
        React.createElement("canvas", { ref: canvasRef, className: "c-audio-player__canvas" }),
        React.createElement("div", { className: "c-audio-player__controls" },
            React.createElement("audio", { ref: audioRef, onEnded: resetAudio, crossOrigin: "anonymous", onPlay: playAudio, className: "c-audio-player__audio", controls: true, onPause: pauseAudio, src: urlSource },
                isAudioStarted && sources.map(({ src, type }) => React.createElement("source", { src: src, type: type })),
                "Your browser does not support the audio tag."))));
};
exports.AudioPlayer = AudioPlayer;
